import { render, staticRenderFns } from "./MagazzinoArticoliListComponent.vue?vue&type=template&id=6978d0e2"
import script from "./MagazzinoArticoliListComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports